var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fm-input-new',{directives:[{name:"loadingx",rawName:"v-loadingx",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"5rem"},attrs:{"size":"small"},on:{"change":_vm.change},model:{value:(_vm.sortNum),callback:function ($$v) {_vm.sortNum=$$v},expression:"sortNum"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }